import { ResultListController } from "../ResultListController";
import { SearchBoxController } from "./SearchBoxController";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { List } from "../../HTML/Container/List/List";
import { ResultItem } from "../../HTML/Page/ResultItem";
import { CFlexContainer } from "../../HTML/Container/CFlexContainer";
import { toMap, log, log2, getWebPageService, getAppService } from "../../../../HA";

export class SearchableController extends ResultListController {
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        const c = new CFlexContainer();
        const l = new List({entryClass: this.getResultItem()});
        if (data.has("pfunc") && data.get("pfunc").itemClick) {
            l.setItemClick(data.get("pfunc").itemClick);
        }
        if (this.showSearchBox()) {
            const sbox = new SearchBoxController({
                kup: (txt: string) => {
                    this.search(txt);
                },
            });
            c.appendChild(sbox);
        }

        c.appendChild(l);
        this.addToData("listTag", l);

        let parentCont = this.get("parentTag");
        if (parentCont) {
            const list = parentCont.fetchByAttribute('rl');
            if (list.length > 0) {
                parentCont = list[0];
            }
        }
        parentCont.appendChild(c);
        this.addToData("tag", c);

        this.addItems(this.get("d"));
        const is = this.get("is");
        if (is) {
            this.addToData("is", toMap(is));
            this.addToData("sd", toMap(is));
            getWebPageService().subscribeToAppInfo(() => {
                if (this.isActive()) {
                    this.initWatch4Reload();
                }
            });
            this.initWatch4Reload();
        }

    }

    protected getResultItem() {
        return ResultItem;
    }

    protected showSearchBox(): boolean {
        return this.get("showSearchBox") !== "no";
    }

    protected search(txt: string): void {
        const is: Map<any, any> = this.get("sd") || new Map();
        is.set("q", txt);
        is.set("los", 0);
        this.addToData("is", toMap(is));
        this.getListTag().clear();
        this.infiniteReload();
    }

    protected initWatch4Reload() {
        if (!this.isActive()) {
            return;
        }
        this.unlock();
        this.watch4Reload(() => {
            this.infiniteReload();
        });
    }

    protected unlock(): void {
        this.addToData("lock", false);
    }

    protected lock(): void {
        this.addToData("lock", true);
    }

    protected isLock(): boolean {
        return this.get("lock") === true;
    }

    protected addItems(items: Map<any, any> | []) {
        if (this.has("m")) {
            const tag = this.getListTag();
            tag.setModel(this.get("m"));
            if (items) {
                items.forEach((i: any) => {
                    tag.addByModel(toMap(i) as Map<string, any>);
                });
            }
        }
    }

    protected getListTag(): List {
        return this.get("listTag");
    }

    protected getAppId(): string | undefined {
        return this.get("appId");
    }

    protected isActive(): boolean {
        return this.has("pfunc") || getWebPageService().isActive(this.getAppId());
    }

    private infiniteReload(): void {
        const is = this.get("is");
        if (!is || is.size < 1 || is.get("los") < 0) {
            this.removeWatch4Reload();
            return;
        }
        if (this.isLock()) {
            return;
        }
        this.lock();

        if (!this.isActive()) {
            this.lock();
            this.removeWatch4Reload();
            return;
        }
        this.getDataRepository().fetchData(is).then((response: Map<any, any>) => {
            const success = response.get("success");

            if (success) {
                const data = toMap(response.get("d"));
                if (data) {
                    this.addItems(data.get("l") as any);
                }
                this.addToData("is", toMap(data.get("is") as any));

                if (!this.isActive()) {
                    this.lock();
                    this.removeWatch4Reload();
                    return;
                }
            } else {
                if (response.has("t")) {
                    getAppService().processAction(response);
                } else if (response.has("msg")) {
                    log(response.get("msg"));
                }
            }
            this.unlock();
        }).catch((reason: any) => {
            log2(["err::searchCtrl", reason, is]);
            this.unlock();
        });
    }

}

ControllerRegistry.register("SearchableController", SearchableController);
